/**
 * 管理后台 - 活动管理 API
 */

import { httpGet, httpPost, httpPut, httpDelete, httpPatch } from '@/services/http';
import { transformEvent, transformEventToBackend, BackendEvent, FrontendEvent } from '@/services/transform';

/** GET /api/admin/events - 列出所有活动 */
export async function getAdminEvents(): Promise<FrontendEvent[]> {
  try {
    const data = await httpGet<BackendEvent[]>('/admin/events');
    return data.map(transformEvent);
  } catch (error) {
    console.error('获取管理活动列表失败:', error);
    return [];
  }
}

/** GET /api/admin/events/stats - 获取活动统计 */
export async function getAdminEventsStats(): Promise<any> {
  try {
    return await httpGet('/admin/events/stats');
  } catch (error) {
    console.error('获取活动统计失败:', error);
    return null;
  }
}

/** POST /api/admin/events - 创建活动 */
export async function createAdminEvent(data: Partial<FrontendEvent>): Promise<FrontendEvent | null> {
  try {
    const backendData = transformEventToBackend(data);
    const result = await httpPost<BackendEvent>('/admin/events', backendData);
    return transformEvent(result);
  } catch (error) {
    console.error('创建活动失败:', error);
    return null;
  }
}

/** PUT /api/admin/events/:id - 更新活动 */
export async function updateAdminEvent(id: string, data: Partial<FrontendEvent>): Promise<FrontendEvent | null> {
  try {
    const backendData = transformEventToBackend(data);
    const result = await httpPut<BackendEvent>(`/admin/events/${id}`, backendData);
    return transformEvent(result);
  } catch (error) {
    console.error('更新活动失败:', error);
    return null;
  }
}

/** DELETE /api/admin/events/:id - 删除活动 */
export async function deleteAdminEvent(id: string): Promise<boolean> {
  try {
    await httpDelete(`/admin/events/${id}`);
    return true;
  } catch (error) {
    console.error('删除活动失败:', error);
    return false;
  }
}

/** PATCH /api/admin/events/batch-status - 批量更新状态 */
export async function batchUpdateEventStatus(ids: string[], status: string): Promise<boolean> {
  try {
    await httpPatch('/admin/events/batch-status', { ids: ids.map(Number), status });
    return true;
  } catch (error) {
    console.error('批量更新活动状态失败:', error);
    return false;
  }
}
